import { render, staticRenderFns } from "./BlockRecordAudio.vue?vue&type=template&id=05ab475a"
import script from "./BlockRecordAudio.vue?vue&type=script&lang=js"
export * from "./BlockRecordAudio.vue?vue&type=script&lang=js"
import style0 from "./BlockRecordAudio.vue?vue&type=style&index=0&id=05ab475a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports